interface IconProps {
  className?: string;
  size?: number;
}

/**
 * The YouTube play mark: the brand-red rounded rectangle with a SOLID white
 * play triangle painted on top.
 *
 * This differs from `YoutubeIcon` (the plain brand logo) on purpose. In the
 * logo the triangle is negative space — a transparent cutout — so on a dark
 * video backdrop the "play" reads as a hole rather than a triangle and is hard
 * to see. Here the triangle is an explicit white shape layered over the red
 * body, so the play affordance stays visible over any thumbnail. `currentColor`
 * still drives the red body (callers set it via `color`), matching how
 * `YoutubeIcon` is themed.
 */
export function YoutubePlayIcon({ className, size }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      {/* Red rounded-rect body (themed via currentColor). */}
      <path
        fill="currentColor"
        d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"
      />
      {/* Solid white play triangle layered on top (not a cutout). */}
      <path fill="#fff" d="M9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
    </svg>
  );
}
